export const marketLosersData = [
    {
      "symbol": "RIBT",
      "name": "RiceBran Technologies",
      "change": -0.1095,
      "price": 0.0805,
      "changesPercentage": -57.6316
    },
    {
      "symbol": "XXII",
      "name": "22nd Century Group, Inc.",
      "change": -1.4317,
      "price": 2.1283,
      "changesPercentage": -40.1407
    },
    {
      "symbol": "PERI",
      "name": "Perion Network Ltd.",
      "change": -7.78,
      "price": 13.33,
      "changesPercentage": -36.8546
    },
    {
      "symbol": "ZJZZT",
      "name": "ZJZZT",
      "change": -6.53,
      "price": 16.9,
      "changesPercentage": -27.8703
    },
    {
      "symbol": "SPCB",
      "name": "SuperCom Ltd.",
      "change": -0.0773,
      "price": 0.2107,
      "changesPercentage": -26.8403
    },
    {
      "symbol": "MDIA",
      "name": "MediaCo Holding Inc.",
      "change": -0.9,
      "price": 2.98,
      "changesPercentage": -23.2558
    },
    {
      "symbol": "HWH",
      "name": "HWH International Inc.",
      "change": -0.31,
      "price": 1.28,
      "changesPercentage": -19.1358
    },
    {
      "symbol": "HUBC",
      "name": "HUB Cyber Security (Israel) Ltd.",
      "change": -0.2907,
      "price": 1.2493,
      "changesPercentage": -18.8693
    },
    {
      "symbol": "BTTR",
      "name": "Better Choice Company Inc.",
      "change": -1.445,
      "price": 6.295,
      "changesPercentage": -18.6934
    },
    {
      "symbol": "NCRA",
      "name": "Nocera, Inc.",
      "change": -0.22,
      "price": 1.1,
      "changesPercentage": -16.6667
    },
    {
      "symbol": "BTOG",
      "name": "Bit Origin Limited",
      "change": -0.6809,
      "price": 3.4391,
      "changesPercentage": -16.5267
    },
    {
      "symbol": "AGEN",
      "name": "Agenus Inc.",
      "change": -0.0827,
      "price": 0.421,
      "changesPercentage": -16.4185
    },
    {
      "symbol": "VSTE",
      "name": "Vast Renewables Limited Ordinary Shares",
      "change": -1.1675,
      "price": 6.0925,
      "changesPercentage": -16.0813
    },
    {
      "symbol": "GCTS",
      "name": "GCT Semiconductor Holding, Inc.",
      "change": -1.31,
      "price": 6.85,
      "changesPercentage": -16.0539
    },
    {
      "symbol": "CNFR",
      "name": "Conifer Holdings, Inc.",
      "change": -0.1705,
      "price": 0.8995,
      "changesPercentage": -15.9346
    },
    {
      "symbol": "DATS",
      "name": "DatChat, Inc.",
      "change": -0.2306,
      "price": 1.2294,
      "changesPercentage": -15.8892
    },
    {
      "symbol": "RELI",
      "name": "Reliance Global Group, Inc.",
      "change": -0.0739,
      "price": 0.4108,
      "changesPercentage": -15.256
    },
    {
      "symbol": "EDBL",
      "name": "Edible Garden AG Incorporated",
      "change": -1.14,
      "price": 6.56,
      "changesPercentage": -14.8052
    },
    {
      "symbol": "TCON",
      "name": "TRACON Pharmaceuticals, Inc.",
      "change": -0.0374,
      "price": 0.2179,
      "changesPercentage": -14.6265
    },
    {
      "symbol": "VLCN",
      "name": "Volcon, Inc.",
      "change": -0.046,
      "price": 0.2801,
      "changesPercentage": -14.0329
    },
    {
      "symbol": "INKT",
      "name": "MiNK Therapeutics, Inc.",
      "change": -0.21,
      "price": 1.35,
      "changesPercentage": -13.4615
    },
    {
      "symbol": "CNSP",
      "name": "CNS Pharmaceuticals, Inc.",
      "change": -0.035,
      "price": 0.225,
      "changesPercentage": -13.4564
    },
    {
      "symbol": "ZPTA",
      "name": "Zapata Computing Holdings Inc. Common Stock",
      "change": -0.3901,
      "price": 2.5599,
      "changesPercentage": -13.2237
    },
    {
      "symbol": "LTCH",
      "name": "Latch, Inc.",
      "change": -0.11,
      "price": 0.75,
      "changesPercentage": -12.7907
    },
    {
      "symbol": "IAUX",
      "name": "i-80 Gold Corp.",
      "change": -0.1701,
      "price": 1.1899,
      "changesPercentage": -12.5202
    },
    {
      "symbol": "GSUN",
      "name": "Golden Sun Education Group Limited",
      "change": -0.0571,
      "price": 0.4019,
      "changesPercentage": -12.4401
    },
    {
      "symbol": "BLBX",
      "name": "Blackboxstocks Inc.",
      "change": -0.3588,
      "price": 2.5312,
      "changesPercentage": -12.4152
    },
    {
      "symbol": "BROG",
      "name": "Brooge Energy Limited",
      "change": -0.2003,
      "price": 1.4297,
      "changesPercentage": -12.2883
    },
    {
      "symbol": "NIVF",
      "name": "NewGenIvf Group Limited",
      "change": -0.12,
      "price": 0.88,
      "changesPercentage": -12.1102
    },
    {
      "symbol": "BIOL",
      "name": "BIOLASE, Inc.",
      "change": -0.0203,
      "price": 0.149,
      "changesPercentage": -11.9905
    },
    {
      "symbol": "EVTV",
      "name": "Envirotech Vehicles, Inc.",
      "change": -0.344,
      "price": 2.556,
      "changesPercentage": -11.8457
    },
    {
      "symbol": "STIX",
      "name": "Semantix, Inc.",
      "change": -0.0515,
      "price": 0.3835,
      "changesPercentage": -11.8391
    },
    {
      "symbol": "VHAI",
      "name": "Vocodia Holdings Corp.",
      "change": -0.0453,
      "price": 0.3517,
      "changesPercentage": -11.4192
    },
    {
      "symbol": "CCTG",
      "name": "CCSC Technology International Holdings Limited Ordinary Shares",
      "change": -0.3844,
      "price": 2.9956,
      "changesPercentage": -11.3728
    },
    {
      "symbol": "ARDS",
      "name": "Aridis Pharmaceuticals, Inc.",
      "change": -0.0086,
      "price": 0.0679,
      "changesPercentage": -11.2418
    },
    {
      "symbol": "NKGN",
      "name": "NKGen Biotech, Inc. Common Stock",
      "change": -0.1539,
      "price": 1.2261,
      "changesPercentage": -11.1522
    },
    {
      "symbol": "NTZ",
      "name": "Natuzzi S.p.A.",
      "change": -0.7,
      "price": 5.6,
      "changesPercentage": -11.1111
    },
    {
      "symbol": "GVH",
      "name": "Globavend Holdings Limited",
      "change": -0.18,
      "price": 1.46,
      "changesPercentage": -10.9756
    },
    {
      "symbol": "TSDD",
      "name": "GraniteShares 1.5x Short TSLA Daily ETF",
      "change": -3.08,
      "price": 25.15,
      "changesPercentage": -10.9104
    },
    {
      "symbol": "EVTL",
      "name": "Vertical Aerospace Ltd.",
      "change": -0.125,
      "price": 1.025,
      "changesPercentage": -10.8696
    },
    {
      "symbol": "NRGV",
      "name": "Energy Vault Holdings, Inc.",
      "change": -0.185,
      "price": 1.545,
      "changesPercentage": -10.6936
    },
    {
      "symbol": "TSLZ",
      "name": "T-Rex 2X Inverse Tesla Daily Target ETF",
      "change": -4.6,
      "price": 39.95,
      "changesPercentage": -10.3417
    },
    {
      "symbol": "RAYA",
      "name": "Erayak Power Solution Group Inc.",
      "change": -0.0729,
      "price": 0.6401,
      "changesPercentage": -10.1901
    },
    {
      "symbol": "OMH",
      "name": "Ohmyhome Limited",
      "change": -0.0888,
      "price": 0.7917,
      "changesPercentage": -10.0294
    },
    {
      "symbol": "EIGR",
      "name": "Eiger BioPharmaceuticals, Inc.",
      "change": -0.2301,
      "price": 2.0699,
      "changesPercentage": -10.0039
    },
    {
      "symbol": "VINE",
      "name": "Fresh Vine Wine, Inc.",
      "change": -0.0792,
      "price": 0.7198,
      "changesPercentage": -9.9485
    },
    {
      "symbol": "SETH",
      "name": "ProShares Short Ether Strategy ETF",
      "change": -1.9821,
      "price": 18.2621,
      "changesPercentage": -9.792
    },
    {
      "symbol": "ROCL",
      "name": "Roth Ch Acquisition V Co.",
      "change": -1.16,
      "price": 10.7,
      "changesPercentage": -9.7808
    },
    {
      "symbol": "DJT",
      "name": "Trump Media & Technology Group Corp.",
      "change": -3.96,
      "price": 36.63,
      "changesPercentage": -9.7417
    },
    {
      "symbol": "RVSN",
      "name": "Rail Vision Ltd.",
      "change": -0.165,
      "price": 1.575,
      "changesPercentage": -9.5095
    }
  ]